import * as Sentry from '@sentry/react';
import 'animate.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import React, { Suspense } from 'react';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import './components/custom-bootstrap.css';
import { StorageProvider } from './hooks/use-storage';
import useWindowDimensions from './hooks/use-window-dimensions';
import { LoadingMenuScreenLazy } from './screens/load/loading-menu-screen-lazy';
import { RedirectOldScreenLazy } from './screens/load/redirect-old-screen-lazy';
import { layoutDefaults } from './utils/layout-defaults';
import { analyticsSetup } from './utils/setup/analytics-setup';
import { axiosSetup, useAxiosLog } from './utils/setup/axios-setup';

// https://github.com/airbnb/javascript/tree/master/react
// https://cssinjs.org/react-jss?v=v10.6.0
// https://www.npmjs.com/package/react-floating-button

analyticsSetup();
axiosSetup();

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

function App() {
  const { initial } = useWindowDimensions();
  const classes = useStyles(initial);
  const { t } = useTranslation();
  useAxiosLog();

  return (
    <div className={isMobile ? null : classes.container}>
      <div className={isMobile ? null : classes.content}>
        <StorageProvider>
          <Router>
            <Suspense
              fallback=<div className={classes.loading}>{t('loading')}...</div>
            >
              <SentryRoutes>
                <Route path="/s/:spotId" element={<LoadingMenuScreenLazy />} />
                <Route
                  path="/q/:qrCodeId"
                  element={<LoadingMenuScreenLazy />}
                />
                <Route path="/m/:menuId" element={<LoadingMenuScreenLazy />} />
                <Route
                  path="/c/:categoryId"
                  element={<LoadingMenuScreenLazy />}
                />
                <Route path="/i/:itemId" element={<LoadingMenuScreenLazy />} />
                <Route
                  path="/:menuSlug/*"
                  element={<LoadingMenuScreenLazy />}
                />
                <Route path="" exact element={<RedirectOldScreenLazy />} />
              </SentryRoutes>
            </Suspense>
          </Router>
        </StorageProvider>
      </div>
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    display: 'grid',
    // background: layoutDefaults.primaryColor,
  },
  content: {
    width: '100%',
    maxWidth: (initial) =>
      isMobile ? initial?.width : layoutDefaults.maxScreenWidth,
    // alignSelf: 'center',
    justifySelf: 'center',

    // border: '1px solid red',
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    fontSize: layoutDefaults.fontSize,
    paddingBottom: 60,
  },
});

export default App;
